import axios from "axios";
import { getBackendEndpoint } from "../../config/env";

const ApiInstance = axios.create({
  baseURL: getBackendEndpoint(),
});

export default ApiInstance;
